const HamburgerSvg = ({
  height = 24,
  width = 24,
  viewBox = '0 0 24 24',
}: {
  height?: number;
  width?: number;
  viewBox?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M2 3H14M2 8H14M2 13H14"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HamburgerSvg;
